import { render } from "./RequestTemplate.vue?vue&type=template&id=17d4398e&scoped=true"
import script from "./RequestTemplate.vue?vue&type=script&lang=js"
export * from "./RequestTemplate.vue?vue&type=script&lang=js"

import "./RequestTemplate.vue?vue&type=style&index=0&id=17d4398e&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17d4398e"]])

export default __exports__